import { useEffect, useState } from 'react';

const EMPTY = {
  idUnidadOrgEmpleado: 0,
  idEmpleado: 0,
  idUnidadOrganizacional: 0,
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (mode === 'edit' && data) {
      setForm({
        idUnidadOrgEmpleado: data.idUnidadOrgEmpleado ?? 0,
        idEmpleado: data.idEmpleado ?? 0,
        idUnidadOrganizacional: data.idUnidadOrganizacional ?? 0,
      });
    } else {
      setForm(EMPTY);
    }
  }, [mode, data]);

  if (!open) return null;

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}
    >
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nueva UnidadOrganizacional - Empleado' : 'Editar UnidadOrganizacional - Empleado'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">
        ✕
      </button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}
    >
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>
          ID Empleado:
        </label>
        <br />
        <br />
        <input
          className="infoField"
          type="number"
          value={form.idEmpleado || 0}
          min={1}
          onChange={(e) =>
            handleChange('idEmpleado', e.target.value ? Number(e.target.value) : 0)
          }
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>
          ID Unidad Organizacional:
        </label>
        <br />
        <br />
        <input
          className="infoField"
          type="number"
          value={form.idUnidadOrganizacional || 0}
          min={1}
          onChange={
            (e) => handleChange(
              'idUnidadOrganizacional',
              e.target.value ? Number(e.target.value) : 0
            )
          }
        />
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>
        Cancelar
      </button>
      <button
        className="btn-action"
        onClick={() => onSubmit(form, mode)}
        disabled={!form.idEmpleado || !form.idUnidadOrganizacional}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div
        className="roles-inline-card"
        style={{ display: 'flex', flexDirection: 'column', gap: 0 }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
